import DOMPurify from 'dompurify'

/**
 * Vue.js Custom Directive: v-sanitize-html
 * @directive sanitize-html
 * @description Sanitizes HTML content using DOMPurify to prevent XSS attacks
 * @param {string|Object} binding.value - HTML content to sanitize or config object
 * @param {string} binding.arg - Security level: 'strict' for maximum security
 * @example
 * <div v-sanitize-html="htmlContent"></div>
 * <div v-sanitize-html:strict="userContent"></div>
 */
const setAsSanitizedInnerHtml = (el, binding) => {
  let options = { ADD_ATTR: ['target', 'data-modal', 'tabindex'] }
  let text = ''
  
  if (typeof binding.value === 'string') {
    text = binding.value
  } else if (binding.value?.text) {
    text = binding.value.text
    options = binding.value.options ?? options
  }
  
  // Handle strict mode
  if (binding.arg === 'strict') {
    options = {
      ...options,
      ALLOWED_TAGS: ['p', 'strong', 'em', 'a', 'ul', 'ol', 'li', 'br', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
      ALLOWED_ATTR: ['href', 'target', 'data-modal', 'tabindex']
    }
  }
  
  el.innerHTML = DOMPurify.sanitize(text, options)
}

const sanitizeHtml = {
  beforeMount: setAsSanitizedInnerHtml,
  updated: setAsSanitizedInnerHtml,
}

export default sanitizeHtml
